import { BankDetailsInput } from 'views/templates/module/bankDetailsInput';
import { InitializeFlags, useApplicationStatus } from './hooks';
import './style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { AccountType } from 'views/utils/enums';
import { InputInvoice } from 'views/mutual/invoice';
import { CorporateFatcaBase } from 'views/templates/accountOpen/fatca';
import { PersonalFatcaBase } from 'views/templates/personalAccountOpen/customerInfo/fatca';
import { ProductType } from 'constants/productType';

type ApplicationStatusType = {
  navigate: () => void;
  initializeFlags: InitializeFlags;
};

export type ApplicationStatusWrapperType = {
  assetType: ProductType;
} & ApplicationStatusType;

export const ApplicationStatusWrapper = (props: ApplicationStatusWrapperType) => {
  switch (props.assetType) {
    case ProductType.DomesticRealEstate: {
      return <DomesticRealEstateApplicationStatus {...props} />;
    }
    case ProductType.OverseasRealEstate: {
      return <OverseasRealEstateApplicationStatus {...props} />;
    }
  }
};

const DomesticRealEstateApplicationStatus = ({ navigate, initializeFlags }: ApplicationStatusType) => {
  useCustomLocationName('国内不動産申し込み事前準備');
  const {
    formik,
    bankDetailsInfoProps,
    fatcaProps,
    invoiceNumberProps,
    hasValidFatcaAnswer,
    hasDividendAccount,
    hasValidInvoiceNumberAnswer,
    accountType,
  } = useApplicationStatus(navigate, {...initializeFlags});

  return (
    <form onSubmit={formik.handleSubmit} className="applicationStatus">
      {!hasValidFatcaAnswer && (
        <>
          <FormContentHeader label="米国納税義務（FATCA）に関する確認" formType={FormType.Required} />
          {accountType == AccountType.Corporate && <CorporateFatcaBase fatcaProps={fatcaProps} />}
          {accountType == AccountType.Personal && <PersonalFatcaBase fatcaProps={fatcaProps} />}
        </>
      )}

      {!hasDividendAccount && (
        <>
          <FormContentHeader label="配当金振り込み用口座" formType={FormType.Required} />
          <div className="applicationStatus_input">
            <BankDetailsInput name="bankInput" {...bankDetailsInfoProps} />
          </div>
        </>
      )}

      {!hasValidInvoiceNumberAnswer && (
        <>
          <FormContentHeader label="インボイス番号" formType={FormType.Required} />
          <InputInvoice {...invoiceNumberProps} />
        </>
      )}
      <Button
        type={ButtonType.Submit}
        label="申込内容の確認へ進む"
        buttonFill={ButtonFill.black}
        buttonSize={ButtonSize.medium}
      />
    </form>
  );
};

const OverseasRealEstateApplicationStatus = ({ navigate, initializeFlags }: ApplicationStatusType) => {
  useCustomLocationName('海外不動産申し込み事前準備');
  const { formik, fatcaProps, hasValidFatcaAnswer } = useApplicationStatus(navigate, {...initializeFlags});

  return (
    <form onSubmit={formik.handleSubmit} className="applicationStatus">
      {!hasValidFatcaAnswer && (
        <>
          <FormContentHeader label="米国納税義務（FATCA）に関する確認" formType={FormType.Required} />
          <CorporateFatcaBase fatcaProps={fatcaProps} />
        </>
      )}
      <Button
        type={ButtonType.Submit}
        label="申込内容の確認へ進む"
        buttonFill={ButtonFill.black}
        buttonSize={ButtonSize.medium}
      />
    </form>
  );
};
